import { CellTable, SortOrder } from "@/atoms"
import { CELLS, getDefaultColumnParams } from "@/helpers/table.helpers"
import { NumberConvertor } from "@/hooks/useNumberConvertor"
import { ORDER_BY_PROPS } from "@/hooks/useOrderBy"
import { TFunction } from "@/hooks/useTranslation"
import { HeaderCell } from "@/molecules/HeaderCell"
import { MoreTableCell } from "@/molecules/MoreTableCell"
import { InstanceCell } from "../../molecules/InstanceCell"
import { MoreTableCellDrawer } from "../../molecules/MoreTableCellDrawer"

import type { ColumnType } from "@/atoms"
import type { getVirtualMachineTabData } from "@/pages/DiscoveryPage/application/virtual-machine-inventory/useVirtualMachine.selector"

export const getColumnsTable = (props: {
  convertors: NumberConvertor
  sorter: Omit<ORDER_BY_PROPS, "onSorterChange">
  t: TFunction
  onRowClick: (record: { key: string }) => void
  previewMode?: boolean
}): ColumnType<
  ReturnType<typeof getVirtualMachineTabData>["data"][number]
>[] => {
  const { sorter, previewMode, onRowClick } = props
  const columns = [
    {
      title: "Instance ID",
      render: InstanceCell,
      ...getDefaultColumnParams("instanceId", sorter),
      sortDirections: ["descend", "ascend", "descend"] as SortOrder[]
    },
    {
      title: "Hostname",
      width: 150,
      render: CellTable,
      ...getDefaultColumnParams("hostname")
    },
    {
      title: "Environment",
      width: 130,
      render: CellTable,
      ...getDefaultColumnParams("environmentName")
    },
    {
      title: "Instance Group",
      width: 130,
      render: MoreTableCell,
      ...getDefaultColumnParams("autoScalingGroups")
    },
    {
      title: "OS",
      width: 75,
      render: CellTable,
      ...getDefaultColumnParams("os")
    },
    CELLS.getIssuesSummaryCell(props),
    {
      title: HeaderCell({
        title: props.t("inventory.vm.thead.relatedProjects.title"),
        Content: props.t("inventory.vm.drawer.configuration.description")
      }),

      width: "20%",
      render: MoreTableCellDrawer(onRowClick),
      ...getDefaultColumnParams("relatedProjects")
    },
    CELLS.getLastDetectedCell({
      entityName: "image",
      t: props.t,
      width: 150,
      ...getDefaultColumnParams("lastDetectionData")
    })
  ]

  if (!previewMode) return columns

  return columns.filter(({ key }) => {
    if (key === "lastDetectionData") return false
    if (key === "os") return false
    if (key === "autoScalingGroups") return false

    return true
  })
}
